/* AD IN A BOX — storefront behaviour. No dependencies. */
(function () {
  'use strict';
  if (window.__aibLoaded) return; window.__aibLoaded = true;

  var money = function (paise) {
    var r = Math.round(paise) / 100;
    return '₹' + r.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  };

  /* ---- Offer forms: bump checkbox + total + buy-now ---- */
  function initOffer(form) {
    var core = form.querySelector('[data-aib-core]');
    var bump = form.querySelector('[data-aib-bump]');
    var total = form.querySelector('[data-aib-total]');
    var btn = form.querySelector('[data-aib-buy]');
    if (!core || !btn) return;

    var corePrice = parseInt(core.getAttribute('data-price'), 10) || 0;
    var bumpPrice = bump ? (parseInt(bump.getAttribute('data-price'), 10) || 0) : 0;
    var label = btn.querySelector('[data-aib-btn-price]');

    function refresh() {
      var sum = corePrice + (bump && bump.checked ? bumpPrice : 0);
      if (total) total.textContent = money(sum);
      if (label) label.textContent = money(sum);
    }
    if (bump) bump.addEventListener('change', refresh);
    refresh();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [{ id: parseInt(core.value, 10), quantity: 1 }];
      if (bump && bump.checked) items.push({ id: parseInt(bump.value, 10), quantity: 1 });
      buy(btn, items);
    });
  }

  /* ---- Standalone "add both" buttons (upsell section) ---- */
  function initAddBoth(el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var ids = (el.getAttribute('data-aib-add-both') || '').split(',').filter(Boolean);
      var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
      buy(el, items);
    });
  }

  function buy(btn, items) {
    var original = btn.innerHTML;
    btn.setAttribute('disabled', 'disabled');
    btn.innerHTML = '<span>Taking you to checkout…</span>';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Clear the cart first so the buyer never ends up with duplicates from an earlier click, then add.
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .catch(function () {})
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = root + 'checkout'; })
      .catch(function () {
        // Fallback: cart permalink (works without JS-side cart access).
        var perma = items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
        window.location.href = root + 'cart/' + perma;
      })
      .finally(function () {
        setTimeout(function () { btn.removeAttribute('disabled'); btn.innerHTML = original; }, 6000);
      });
  }

  /* ---- Anchor CTAs: if the anchor isn't on this page, use the fallback URL ---- */
  function initFallbacks() {
    document.querySelectorAll('a[data-aib-fallback]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      if (!document.getElementById(href.slice(1))) link.setAttribute('href', link.getAttribute('data-aib-fallback'));
    });
  }

  /* ---- Sticky mobile CTA ---- */
  function initSticky(bar) {
    var hero = document.querySelector('[data-aib-hero]');
    var show = function (v) { bar.classList.toggle('is-visible', v); document.documentElement.style.setProperty('--aib-sticky-h', v ? bar.offsetHeight + 'px' : '0px'); };
    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        show(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(hero);
    } else {
      var onScroll = function () { show(window.scrollY > 240); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    // Hide when the main offer card is on screen (button would be redundant)
    var offer = document.querySelector('[data-aib-offer]');
    if (offer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('aib-sticky--muted', entries[0].isIntersecting);
      }, { threshold: 0.35 }).observe(offer);
    }
  }

  function init() {
    initFallbacks();
    document.querySelectorAll('[data-aib-offer-form]').forEach(initOffer);
    document.querySelectorAll('[data-aib-add-both]').forEach(initAddBoth);
    var bar = document.querySelector('[data-aib-sticky]');
    if (bar) initSticky(bar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
